import { render } from "./Footer.vue?vue&type=template&id=278740cb&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=278740cb&lang=scss&scoped=true"

import exportComponent from "D:\\ideaWorkSpace\\政泉\\zhengquan\\sqlpj-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278740cb"]])

export default __exports__